export default "__VITE_ASSET__DPSBclhR__"